import './App.css';
import IframeMain from './Components/IframeMain';
import Home from './Components/Home';
import {Routes, Route} from 'react-router-dom'

function App() {
  return (
    <Routes>
      <Route path='/' element={<IframeMain />} />
      <Route path='/show' element={<Home />} />
    </Routes>
  );
}

export default App;
